import * as moment from "moment";
import * as numeral from "numeral";

//Base 64 编码
function encode64(input) {
    let keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    let output = "";
    let chr1,
        chr2,
        chr3 = "";
    let enc1,
        enc2,
        enc3,
        enc4 = "";
    let i = 0;
    do {
        chr1 = input.charCodeAt(i++);
        chr2 = input.charCodeAt(i++);
        chr3 = input.charCodeAt(i++);
        enc1 = chr1 >> 2;
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
        enc4 = chr3 & 63;
        if (isNaN(chr2)) {
            enc3 = enc4 = 64;
        } else if (isNaN(chr3)) {
            enc4 = 64;
        }
        output = output + keyStr.charAt(enc1) + keyStr.charAt(enc2) + keyStr.charAt(enc3) + keyStr.charAt(enc4);
        chr1 = chr2 = chr3 = "";
        enc1 = enc2 = enc3 = enc4 = "";
    } while (i < input.length);
    return output;
}
function utf16to8(str) {
    let out, i, len, c;

    out = "";
    len = str.length;
    for (i = 0; i < len; i++) {
        c = str.charCodeAt(i);
        if (c >= 0x0001 && c <= 0x007f) {
            out += str.charAt(i);
        } else if (c > 0x07ff) {
            out += String.fromCharCode(0xe0 | ((c >> 12) & 0x0f));
            out += String.fromCharCode(0x80 | ((c >> 6) & 0x3f));
            out += String.fromCharCode(0x80 | ((c >> 0) & 0x3f));
        } else {
            out += String.fromCharCode(0xc0 | ((c >> 6) & 0x1f));
            out += String.fromCharCode(0x80 | ((c >> 0) & 0x3f));
        }
    }
    return out;
}

const util = {
    /**
     * 生成UUID
     * @param len 长度，一般不需要传
     * @param radix 基数，一般不需要传
     * @returns uuid
     */
    uuid(len, radix) {
        let chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
        let arr = [],
            i;
        radix = radix || chars.length;
        if (len) {
            // Compact form
            for (i = 0; i < len; i++) {
                arr[i] = chars[0 | (Math.random() * radix)];
            }
        } else {
            // rfc4122, version 4 form
            let r; // rfc4122 requires these characters
            arr[8] = arr[13] = arr[18] = arr[23] = "-";
            arr[14] = "4"; // Fill in random data. At i==19 set the high bits of clock sequence as // per rfc4122, sec. 4.1.5
            for (i = 0; i < 36; i++) {
                if (!arr[i]) {
                    r = 0 | (Math.random() * 16);
                    arr[i] = chars[i === 19 ? (r & 0x3) | 0x8 : r];
                }
            }
        }
        return arr.join("");
    },
    /**
     * 日期格式化
     * @param val 日期构建参数，支持所有满足moment的构建参数，为空时构建当前系统时间
     * @param format 格式化字符串
     * @returns 格式化后的日期字符串
     */
    formatDate(val, format) {
        let date;
        if (val) {
            date = moment(val);
        } else {
            date = moment();
        }
        format = format || "YYYY-MM-DD HH:mm:ss";
        let res = date.format(format);
        if (res === "Invalid date") {
            return val;
        }
        return res;
    },
    /**
     * 日期格式化
     * @param val 日期构建参数，支持所有满足moment的构建参数
     * @param format 格式化字符串
     * @returns 格式化后的日期字符串
     */
    formatDateAllowNull(val, format) {
        let date;
        if (val) {
            date = moment(val);
        } else {
            return val;
        }
        format = format || "YYYY-MM-DD HH:mm:ss";
        let res = date.format(format);
        if (res === "Invalid date") {
            return val;
        }
        return res;
    },
    /**
     * 数值格式化
     * @param val 格式化前值，为空时返回null
     * @param format 格式化字符串
     * @returns 格式化后的数值字符串
     */
    formatNumber(val, format) {
        if (!val) return null;
        format = format || "0,0";
        return numeral(val).format(format);
    },
    /**
     * 时间戳转换日期格式
     * @param timestamp 时间戳
     * @returns 格式化后的日期字符串
     */
    timestampToTime(timestamp) {
        if (!timestamp) {
            return null;
        }
        let datetime = new Date(timestamp); //其中timestamp为字符串
        let year = datetime.getFullYear();
        let month = datetime.getMonth() + 1 < 10 ? "0" + (datetime.getMonth() + 1) : datetime.getMonth() + 1;
        let day = datetime.getDate() < 10 ? "0" + datetime.getDate() : datetime.getDate();
        let hour = datetime.getHours() < 10 ? "0" + datetime.getHours() : datetime.getHours();
        let minute = datetime.getMinutes() < 10 ? "0" + datetime.getMinutes() : datetime.getMinutes();
        let second = datetime.getSeconds() < 10 ? "0" + datetime.getSeconds() : datetime.getSeconds();
        return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
    },
    /**
     * 将字符串编码为可在url中安全传递的Base64变种字符串
     * @param input 原始字符串
     * @returns 编码后的字符串
     */
    encodeURL(input) {
        if (input === null || input === "" || input === undefined) return "";
        return encode64(utf16to8(input))
            .replace(/\+/g, "-")
            .replace(/\//g, "_")
            .replace(/=/g, "");
    },
    /**
     * 日期加上月、日、时
     * @param date 初始日期
     * @param type 加减单位（月month、日day、时hour）
     * @param num 增减间隔
     * @returns 编码后的字符串
     */
    dateAdd(date, type, num) {
        if (type === "month") {
            let addmonth = date.setMonth(date.getMonth() + num);
            return this.formatDate(new Date(addmonth));
        } else if (type === "day") {
            let addday = date.setDate(date.getDate() + num);
            return this.formatDate(new Date(addday));
        } else if (type === "hour") {
            let addhour = date.setHours(date.getHours() + num);
            return this.formatDate(new Date(addhour));
        }
        return this.formatDate(date);
    },
    /**
     * 日期相减获得月、日、时等差值
     * @param date1 开始日期
     * @param date2 结束日期
     * @param type 差值单位（月month、日day、时hour）
     * @returns 编码后的字符串
     */
    dateSubtract(datestr1, datestr2, type) {
        let date1 = new Date(datestr1);
        let date2 = new Date(datestr2);
        let s1 = date1.getTime();
        let s2 = date2.getTime();
        let total = (s2 - s1) / 1000;
        let day = parseInt(total / (24 * 60 * 60)); //计算整数天数
        return day;
    },
    /**
     * 树形选择control_no条件拼接
     * @param fieldName 字段名
     * @param controlNo 值（string/string[]）
     * @returns 拼接后的sql段
     */
    controlNoLikeSql(fieldName, controlNo, tree_lb) {
        let condition = "";
        if (controlNo !== null) {
            if (typeof controlNo === "string") {
                if (tree_lb === null || tree_lb === 1) {
                    return " and " + fieldName + " like '" + controlNo + "%' ";
                } else {
                    if (controlNo.indexOf("_") < 0) {
                        return " and zdlx = " + controlNo + " ";
                    } else {
                        return " and zdmc = '" + controlNo.substring(6) + "' ";
                    }
                }
            }
            condition += " and (";
            // 区域数据分析多选
            controlNo.forEach((item, index) => {
                condition += fieldName + " like '" + item + "%' ";
                if (index < controlNo.length - 1) {
                    condition += " OR ";
                }
            });
            condition += " )";
        }
        return condition;
    },
    /**
     * 获取查询时间段的所需表
     * @param {表名主题} tablenamepart
     * @param {查询开始时间} kssj
     * @param {查询结束时间} jssj
     * @returns 拼接后的sql段
     */
    getSelectTableNames(tablenamepart, kssj, jssj) {
        let tablenames = [];
        let ksdate = new Date(kssj);
        let jsdate = new Date(jssj);
        let ksmonths = ksdate.getFullYear() * 12 + ksdate.getMonth() + 1;
        let jsmonths = jsdate.getFullYear() * 12 + jsdate.getMonth() + 1;
        for (let i = ksmonths; i <= jsmonths; i++) {
            let nf = ksdate.getFullYear();
            let yf = ksdate.getMonth() + 1;
            let tablename = tablenamepart + "_" + nf + (yf > 9 ? "" + yf : "0" + yf);
            ksdate.setMonth(ksdate.getMonth() + 1);
            tablenames.push(tablename);
        }
        return tablenames;
    },
    /**
     * 拼接查询SQL视图
     * @param {*} kssj
     * @param {*} jssj
     * @param {*} condition
     * @param {*} sjlx
     */
    getSelectTableSql(tablenamepart, kssj, jssj, condition) {
        let sql = "";
        let tablenames = this.getSelectTableNames(tablenamepart, kssj, jssj);
        for (let i = 0; i < tablenames.length; i++) {
            let tablename = tablenames[i];
            sql += "SELECT * FROM(";
            sql += "SELECT a.*, ZDBH,ZDMC,ZDLX,ZDJB,LXBJ,QYMC,CONTROL_NO,concat(control_no,zdbh) AS CONTROL_NO_ZDBH ";
            sql += "FROM " + tablename + " a ";
            sql += "left join jc_zdxx zd on zd.id = a.zdid ";
            sql += "left join jc_qyxx qy on qy.id = zd.qyid ";
            sql += ") AS TEMP WHERE 1=1 " + condition;
            if (i < tablenames.length - 1) {
                sql += " union all ";
            }
        }
        return sql;
    },
    /**
     * 拼接查询日数据SQL视图
     * @param {*} kssj
     * @param {*} jssj
     * @param {*} condition
     * @param {*} sjlx
     */
    getSelectTableSqlBySJLX(tablenamepart, kssj, jssj, condition, sjlx) {
        let sql = "";
        let tablenames = this.getSelectTableNames(tablenamepart, kssj, jssj);
        for (let i = 0; i < tablenames.length; i++) {
            let tablename = tablenames[i];
            sql += "SELECT * FROM(SELECT a.id, nf, yf, dd, zdid, sj, ";
            if (sjlx === 0) {
                sql += "pm25_s pm25, pm10_s pm10, o3_s o3, so2_s so2, co_s co, no2_s no2, no_s no, nox_s nox, ";
            } else {
                sql += "pm25, pm10, o3, so2, co, no2, no, nox, ";
            }
            sql += "ha, ta, ws, a.wd, at, rf, fv, ";
            sql += "ZDBH,ZDMC,ZDLX,ZDJB,LXBJ,QYMC,CONTROL_NO,concat(control_no,zdbh) AS CONTROL_NO_ZDBH ";
            sql += "FROM " + tablename + " a ";
            sql += "left join jc_zdxx zd on zd.id = a.zdid ";
            sql += "left join jc_qyxx qy on qy.id = zd.qyid ";
            sql += ") AS TEMP WHERE 1=1 " + condition;
            if (i < tablenames.length - 1) {
                sql += " union all ";
            }
        }
        return sql;
    },
    /**
     * 列表实况标况切换
     * @param {*} data 数据
     * @param {*} type 类型 0 实况 1 标况
     */
    dataChange(data, type) {
        if (data) {
            if (type === 0) {
                data.forEach((item) => {
                    item.pm25 = item.pm25_s;
                    item.pm10 = item.pm10_s;
                    item.o3 = item.o3_s;
                    item.so2 = item.so2_s;
                    item.co = item.co_s;
                    item.no2 = item.no2_s;
                    item.no = item.no_s;
                    item.nox = item.nox_s;
                });
            } else {
                data.forEach((item) => {
                    item.pm25 = item.pm25_b;
                    item.pm10 = item.pm10_b;
                    item.o3 = item.o3_b;
                    item.so2 = item.so2_b;
                    item.co = item.co_b;
                    item.no2 = item.no2_b;
                    item.no = item.no_b;
                    item.nox = item.nox_b;
                });
            }
        }
    },
    /**
     * 自动获取列表高度
     * @param {type} type 查询条件行数
     * @returns 列表高度
     */
    getTableHeightDirect(type) {
        let topHeight = 208;
        let clientHeight = document.documentElement.clientHeight;
        let searchHeight = -5;
        if (type === 1) {
            searchHeight = 85;
        } else if (type === 2) {
            searchHeight = 126;
        } else if (type === 3) {
            searchHeight = 172;
        }
        return clientHeight - topHeight - searchHeight;
    }
};
export default util;
